import { Component, inject, output, signal } from '@angular/core';
import { copyToClipBoard } from '@app/shared/text.helper';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { mgcIconCopy2Regular } from '@sb/mgc-icons/mgcIcon-copy_2_regular.icon';
import { mgcIconUpload3Regular } from '@sb/mgc-icons/mgcIcon-upload_3_regular.icon';
import { ButtonComponent } from '@sb/ui/button';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import { ToastService } from '@sb/ui/toast';
import { clsx } from 'clsx';

const EXAMPLE_VARIABLE = 'start_date';

/** How to add a field detection missed to the contract by hand, ending with the upload of the fixed file. */
@Component({
  selector: 'missing-field-panel',
  templateUrl: './missing-field-panel.component.html',
  imports: [ButtonComponent, IconComponent, TranslatePipe],
  host: { '[class]': 'hostClasses' },
})
export class MissingFieldPanelComponent {
  hostClasses = clsx('flex flex-col gap-md rounded-xl border border-dashed border-default p-lg');

  #translate = inject(TranslateService);
  #toast = inject(ToastService);

  uploadAgain = output();

  isOpen = signal(false);
  exampleVariable = EXAMPLE_VARIABLE;

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconCopy2Regular, mgcIconUpload3Regular]);
  }

  copy(): void {
    copyToClipBoard(`{${EXAMPLE_VARIABLE}}`);
    this.#toast.openSuccess(
      this.#translate.instant('Variable [variable] copied to clipboard', { variable: EXAMPLE_VARIABLE }),
    );
  }
}
